module.exports = __webpack_public_path__ + "5de93c3375c276a0b0e8724a68683b33.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/7/norstat_survey.jpg
// module id = 248
// module chunks = 0